import { useEffect, useState } from "react";
import { Analytics, PDFViewer } from "../components"
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/auth-context";
import { useParams } from 'react-router-dom';
// import { log } from "../utils/log_utils";
import { getResumeComments, getSharedResume } from "../api/resume";
import { CommentSectionUI } from "../components/CommentSectionUI";
import { addResumeComment } from "../api/comments";

export const ShareableAnalysisPage = () => {

    const { token } = useParams();
    const { user } = useAuth();
    const [data, setData] = useState(null);
    const [shareConfig, setShareConfig] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState();
    const [isAddingComment, setIsAddingComment] = useState(false)



    const fetchComments = async () => {
        if (!data?.id) return;
        const { success, resp } = await getResumeComments(data.id);
        if (success) {
          setData(resume => {
            resume.comments = resp
            return resume
          });
        }
      }


    // Check if access is allowed based on shareConfig
    const isAccessAllowed = () => {
        
        // If no shareConfig, allow access
        if (!shareConfig || Object.keys(shareConfig).length === 0) return true;
        
        // Check visibility settings
        if (shareConfig.visibility === "public") return true;
        if (shareConfig.visibility === "protected") return !!user;
        // Default to allowing access
        return true;
    };

    // Check if analysis should be shown
    const shouldShowAnalysis = () => {
        
        // If no shareConfig, show analysis
        if (!shareConfig || Object.keys(shareConfig).length === 0) return false;
        
        // Check showAnalysis flag
        return shareConfig.showAnalysis !== false;
    };
    
    const shouldShowComments = () => {
        
        // If no shareConfig, show analysis
        if (!shareConfig || Object.keys(shareConfig).length === 0) return false;
        
        // Check showComments flag
        return shareConfig.showComments !== false;
    };

    const addComment = async (text) => {
        setError('');
        setIsAddingComment(true)
        if(!token || !text || !data.id){
            setError("invalid inputs")
            setIsLoading(false)
            return
        }
        const { success, resp } = await addResumeComment(data.id, text, token);
        if (success) {
          await fetchComments();
        } else {
          setError(resp);
        }
        setIsAddingComment(false)
      };

    useEffect(() => {
        let isMounted = true;
        setIsLoading(true);
        if (token) {
            const loadSharedResume = async () => {
                const { success, resp } = await getSharedResume(token);
                if (!isMounted) return;
                
                if (success) {
                    const { resume, shareConfig } = resp;
                    setData(resume);
                    setShareConfig(shareConfig);
                } else {
                    setError(resp);
                }
                setIsLoading(false);
            };
            loadSharedResume();
        }
    
        return () => { isMounted = false; };
    }, [token]);

    if (isLoading) {
        return <div className="flex justify-center items-center h-64"><Loader2 className="animate-spin h-12 w-12 text-indigo-600" /></div>;
    }
    
    if (!data) return <div className="text-center text-red-500">Could not load analysis.</div>;


    // Check access permissions
    if (!isAccessAllowed()) {
        return (
                <div className="flex justify-center items-center h-64">
                    <div className="text-center">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Access Restricted</h2>
                        <p className="text-gray-600 mb-6">This resume analysis is only available to logged-in users.</p>
                    </div>
                </div>
        );
    }

    const { analysis } = data;

    return (
        <div className="bg-gradient-to-b from-white to-indigo-50 fade-in w-full">
            {/* <ShareCTA setView={setView} /> */}
            <div className="bg-white p-4 rounded-xl border mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Resume Analysis Report</h2>
                <p className="text-gray-600">Shared for feedback on the role of: <span className="font-semibold">{data.role}</span></p>
            </div>
            {
                error && <p className="text-red-500 font-semibold mb-8">{"*" + error}</p>
            }
             <div className="w-full md:w-4/5 lg:w-4/5 xl:w-3/4 2xl:w-2/3 pb-12 mx-auto flex flex-col gap-8">
                <PDFViewer url={data.resumeURL || data.resume_url} />
                {shouldShowAnalysis() && <Analytics analysis={analysis} viewOnly={true} />}
                {shouldShowComments() &&  <CommentSectionUI
                                                comments={data.comments}
                                                onAddComment={addComment}
                                                loading={isAddingComment}
                                                error={error}
                                                isCommentsDisabled={!user}
                                                />}
            </div>
        </div>
    );
};